import React, { useState } from 'react'

import './ScrollUpButton.scss'

type Props = {}

const ScrollUpButton = (props: Props) => {
    const [scrollUpState, setScrollUpState] = useState<boolean>(false)
    window.addEventListener('scroll', function () {
        window.scrollY > 2000 ? setScrollUpState(true) : setScrollUpState(false)
    })

    const onScrollUpClick = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        })
    }

    return (
        <div
            className={`scroll-up ${
                scrollUpState ? 'show-scroll-up' : 'hide-scroll-up'
            }`}
            onClick={onScrollUpClick}
        ></div>
    )
}

export default ScrollUpButton
